import { extend } from "vee-validate";
import { messages } from "vee-validate/dist/locale/ro.json";
import * as rules from "vee-validate/dist/rules";
import { isValidCnp, normalizeCnp } from "@/helpers/resdps";

const veeValidateConfigure = () => {
  Object.keys(rules).forEach((rule) => {
    extend(rule, {
      ...rules[rule],
      message: messages[rule],
    });
  });

  // CNP-ul din formularul R.E.S.D.P.S.: acelasi algoritm ca in API. Nasterea fata de data decesului o verifica API-ul.
  extend("cnp", {
    validate: (value) => isValidCnp(normalizeCnp(value), null, new Date()),
    message: "CNP-ul nu este valid.",
  });
};

export default veeValidateConfigure;
